// userInteractReducer.js
import { SET_USER_INTERACT_ON, SET_USER_INTERACT_OFF } from "../reduxConstants";

const initialState = {
  isUserInteract: false,
};

export default function userInteractReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INTERACT_ON:
      return { ...state, isUserInteract: true };

    case SET_USER_INTERACT_OFF:
      return { ...state, isUserInteract: false };

    default:
      return state;
  }
}
